import TextField from "../../ui/TextField";
import React, { Fragment, useState, useEffect, useRef, useMemo } from "react";
import { Modal, Box, Typography, Button, Divider } from "@mui/material";
import { apiTomaInventarioBuscarArticulos } from "../../../settings/ApiConfig";
import { useRequest } from "../../../context/System/RequestContext";
import { useLayout } from "../../../context/System/LayoutContext";
import SizeSoftXTablePaginadoFilter from "../../leyout/SizeSoftXTablePaginadoFilter";

const modalStyle = {
    position: 'fixed',
    top: 0,
    right: '9%',
    width: '81vw',
    height: '100vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '9px',
};

export default function ModalBuscarTomaInventario({ openModal, handleCloseModal, onSelectToma }) {
    const { GetRequest } = useRequest();
    const { handleOpenAlert } = useLayout();

    const filterRef = useRef(null);
    const tableRef = useRef(null);

    const [filtro, setFiltro] = useState("");
    const [listaAgrupada, setListaAgrupada] = useState([]);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [rowSelect, setRowSelect] = useState({});

    const persistRef = useRef({ filtro: "", lista: [], indexSel: -1 });

    useEffect(() => {
        if (openModal) {
            setFiltro(persistRef.current.filtro);
            setListaAgrupada(persistRef.current.lista);
            setRowSelect({});
            setTimeout(() => {
                if (filterRef.current && openModal) {
                    filterRef.current.focus();
                    filterRef.current.select();
                }
            }, 0);
        }
    }, [openModal]);

    useEffect(() => {
        persistRef.current.filtro = filtro;
    }, [filtro]);

    const handleSearch = async () => {
        const q = filtro.trim();
        if (!q) return;
        setListaAgrupada([]);
        setRowSelect({});
        try {
            const response = await GetRequest({
                url: apiTomaInventarioBuscarArticulos + "?q=" + encodeURIComponent(q),
                loader: "Buscando inventarios...",
            });
            if (response.hasError) {
                handleOpenAlert(response.message || "Error al buscar");
                return;
            }
            const items = Array.isArray(response.result) ? response.result : [];
            setListaAgrupada(items);
            setTotalRegistros(items.length);
            persistRef.current = { filtro, lista: items, indexSel: -1 };
            if (items.length > 0) {
                setTimeout(() => {
                    setRowSelect(items[0]);
                    tableRef.current?.focus();
                }, 100);
            }
        } catch {
            handleOpenAlert("Error al buscar inventarios");
        }
    };

    const handleChangeFilter = (e) => {
        setRowSelect({});
        setFiltro(e.target.value);
    };

    const handleOnKeyDownFilter = async (e) => {
        const { key } = e;
        switch (key) {
            case "ArrowDown":
                if (filtro.trim().length === 0) return;
                if (listaAgrupada.length > 0) {
                    setRowSelect(listaAgrupada[0]);
                    tableRef.current?.focus();
                }
                break;
            case "Enter":
                e.preventDefault();
                await handleSearch();
                break;
            default:
                break;
        }
    };

    const handleCargar = () => {
        if (!rowSelect?.folioinventario) return;
        onSelectToma && onSelectToma(rowSelect);
        handleCloseModal();
    };

    const handleDoubleClickRow = (row) => {
        if (!row?.folioinventario) return;
        setRowSelect(row);
        handleCargar();
    };

    const handleChanceRow = (e) => {
        setRowSelect(e);
    };

    const handleKeyDown = (event) => {
        const { key } = event;
        if (key === "ArrowDown" || key === "ArrowUp" || key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!listaAgrupada || listaAgrupada.length === 0) return;

        const currentIndex = listaAgrupada.findIndex(
            (x) => x.folioinventario === rowSelect?.folioinventario
        );

        switch (key) {
            case "ArrowDown":
                if (currentIndex === -1) {
                    handleChanceRow(listaAgrupada[0]);
                } else if (currentIndex < listaAgrupada.length - 1) {
                    handleChanceRow(listaAgrupada[currentIndex + 1]);
                }
                break;
            case "ArrowUp":
                if (currentIndex === -1) {
                    handleChanceRow(listaAgrupada[listaAgrupada.length - 1]);
                } else if (currentIndex > 0) {
                    handleChanceRow(listaAgrupada[currentIndex - 1]);
                } else {
                    if (filterRef.current) filterRef.current.focus();
                }
                break;
            case "Enter":
                if (rowSelect?.folioinventario) {
                    handleCargar();
                }
                break;
            default:
                break;
        }
    };

    const columns = useMemo(() => [
        { title: "Folio", field: "folioinventario", width: 60 },
        {
            title: "Artículos",
            field: "totalArticulos",
            width: 70,
            type: "numeric",
        },
        {
            title: "Suma C1",
            field: "sumaConteo1",
            width: 70,
            type: "numeric",
            render: (r) => Number(r.sumaConteo1 || 0).toFixed(2),
        },
        {
            title: "Suma C2",
            field: "sumaConteo2",
            width: 70,
            type: "numeric",
            render: (r) => Number(r.sumaConteo2 || 0).toFixed(2),
        },
        {
            title: "Suma C3",
            field: "sumaConteo3",
            width: 70,
            type: "numeric",
            render: (r) => Number(r.sumaConteo3 || 0).toFixed(2),
        },
    ], []);

    return (
        <Modal
            open={openModal}
            onClose={(event, reason) => {
                if (reason === "backdropClick") return;
                handleCloseModal();
            }}
        >
            <Box sx={modalStyle}>
                <Fragment>
                    <div className="bannerbuscadorarticulos">
                        <p className="titulobuscadorarticulos">Buscador de Tomas de Inventario</p>
                        <div className="filtrobuscadorarticulos">
                            <TextField autoComplete="off"
                                name="Filtro"
                                label="Descripción:"
                                inputRef={filterRef}
                                value={filtro}
                                onChange={handleChangeFilter}
                                onFocus={(e) => e.target.select()}
                                onKeyDownCapture={handleOnKeyDownFilter}
                                type="text"
                                inputProps={{ maxLength: 50, minLength: 2 }}
                                sx={{ margin: '.1rem .1rem', width: '270px' }}
                            />
                        </div>
                        <div className="tablaarticulosfiltrados">
                            <div
                                tabIndex={0}
                                ref={tableRef}
                                onKeyDownCapture={handleKeyDown}
                            >
                                <SizeSoftXTablePaginadoFilter
                                    columns={columns}
                                    data={listaAgrupada}
                                    totalDeRegistros={totalRegistros}
                                    id="folioinventario"
                                    row={rowSelect}
                                    setRow={handleChanceRow}
                                    fontSize="small"
                                    rowsPerPageSet={50}
                                    EspaciadorColumnas={1}
                                    onRowDoubleClick={handleDoubleClickRow}
                                />
                            </div>
                        </div>
                        <Divider sx={{ mt: 1, mb: 1 }} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 16px', backgroundColor: '#f5f5f5' }}>
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                Total Inventarios: {totalRegistros}
                            </Typography>
                            <div style={{ display: 'flex', gap: 8 }}>
                                <Button
                                    variant="outlined"
                                    onClick={handleCloseModal}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleCargar}
                                    disabled={!rowSelect?.folioinventario}
                                >
                                    Cargar
                                </Button>
                            </div>
                        </div>
                    </div>
                </Fragment>
            </Box>
        </Modal>
    );
}
